import { takeEvery, call, put, all, select } from 'redux-saga/effects'
import { cleanSettings, saving } from '../../../../store/Settings/actions'
import { SAVE_SETTINGS } from '../../../../store/Settings/actions/sets/Advert/Tracks'
import { loadClips } from '../../../../store/Settings/actions/components/Clips'
import { loadTracks } from '../../../../store/Tracks/actions'
import { loadIndentObjects } from '../../../../store/Objects/actions'
import { buildGETUrl } from '../../../../utilities/buildGETUrl'
import { showAlertError, showAlertSuccess } from '../../../../store/Alert/actions'
import axios from 'axios'
import { reloadValue } from '../../../../store/Search/actions'

export default function* () {
    yield takeEvery(SAVE_SETTINGS, worker)
}

function* worker({ payload }) {
    console.log("SAVE_SETTINGS", { payload });

    yield put(saving({ ...payload, __saving: true }))


    try {
        const {
            type,
            indentIds,
            objectIds,
            stateKey,
            settings
        } = payload
        const selectedGroups = yield select(state => state.objectsGroup.selected)

        const saved = yield call(fetchSave, indentIds, selectedGroups.length > 0 ? selectedGroups : objectIds, settings)

        console.log({saved});

        if (saved.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${SAVE_SETTINGS}.`, saved],
                text: saved.error
            }))
        } else {
            if (saved.warning) {
                yield put(showAlertSuccess({
                    responses: [`Успешное выполнение ${SAVE_SETTINGS}.`, saved],
                    text: saved.warning
                }))
            } else {
                yield put(showAlertSuccess({
                    responses: [`Успешное выполнение ${SAVE_SETTINGS}.`, saved],
                    text: `Настройки успешно сохранены.`
                }))
            }

            yield put(cleanSettings({
                type,
                stateKey
            }))

            console.log({
                indentIds,
                objectIds,
                required: true
            });


            yield put(loadIndentObjects())

            // yield all(
            //     indentIds.map(indentId =>
            //         put(loadClips({
            //             indentId,
            //             objectIds,
            //             required: true
            //         }))
            //     )
            // )

            yield put(loadTracks({ callback: reloadValue, id: indentIds }))


        }
    }

    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${SAVE_SETTINGS}.`, e],
            text: e.message
        }))
    }

    finally {
        yield put(saving({ ...payload, __saving: false }))
    }
}

function fetchSave(indentIds, objectIds, settings) {
    if ((!settings.todate || settings.todate === "") && settings.fromdate?.length) {
        settings.todate = settings.fromdate;
    }

    if (settings.__inhour && settings.__inhour !== 0) delete settings.block;
    if (settings.__inday && settings.__inday === true) settings.daymask = 85;
    if (settings.block && settings.block !== "0" && settings.block?.length) delete settings.steptime;

    if (!settings.fromtime || settings.fromtime === "") delete settings.fromtime;
    if (!settings.totime || settings.totime === "") delete settings.totime;
    if (!settings.steptime || settings.steptime === "") delete settings.steptime;

    delete settings.__settingsType;
    delete settings.__saving;
    delete settings.__inday;

    const formData = new FormData();
    formData.append('indent_id', indentIds.join(","));
    formData.append('ms_id', objectIds.join(","));

    // Append all remaining settings to FormData
    for (const key in settings) {
        if (settings[key] !== undefined && settings[key] !== null) {
            formData.append(key, settings[key]);
        }
    }

    return axios(
        {
            url: "/timeline/clip/insert",
            method: "POST",
            data: formData,

        })
        .then(response => response.data)
}
function convertInhourToBlock(value) {
    const step = 12 / value
    let blocks = []

    let block = 0
    for (let i = 0; i < value; i++) {
        blocks.push(Math.round(block + step))
        block += step
    }
    return blocks.join(",")
}